import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { reduxForm, Form, Field } from 'redux-form/immutable'
import { FormattedMessage, injectIntl } from 'react-intl'

import CreatableSelect from 'react-select/creatable'

import RadioGroupComponent from './components/RadioGroup'
import SendingFrequencySubComponent from './components/SendingFrequencySubComponent'

import { LOCALE_PREFIX, SENDING_FREQUENCY_DEFINITIONS, SENDING_METHOD_DEFINITIONS, FORM_KEY } from './constants'
import { RADIO_GROUP_ORIENTATIONS } from './components/RadioGroup/constants'

const selectStyle = {
    control: (base, state) => ({
        ...base,
        backgroundColor: 'white',
        boxShadow: state.isFocused ? 'inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 126, 255, 0.1)' : 'none',
    }),
    multiValue: (base) => ({
        ...base,
        border: '1px solid rgba(0, 126, 255, 0.24)',
        borderRadius: 2,
        color: '#007eff',
        backgroundColor: 'rgba(0, 126, 255, 0.08)',
    }),
    multiValueLabel: (base) => ({
        ...base,
        order: 1,
        color: '#007eff',
        paddingLeft: 3,
        paddingRight: 6,
    }),
    multiValueRemove: (base) => ({
        ...base,
        cursor: 'pointer',
    }),
    clearIndicator: (base) => ({
        ...base,
        cursor: 'pointer',
    }),
    option: (base) => ({
        ...base,
        cursor: 'pointer',
    }),
    menu: (base) => ({
        ...base,
        marginTop: 2,
        marginBottom: 2,
    }),
    noOptionsMessage: (base) => ({
        ...base,
        textAlign: 'left',
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    dropdownIndicator: () => ({
        display: 'none',
    }),
}

@injectIntl
@reduxForm({ form: FORM_KEY, touchOnChange: true })
export default class GroupMonitoringForm extends Component {
    static propTypes = {
        intl: PropTypes.object.isRequired,
        sendingFrequency: PropTypes.string.isRequired,
    }

    onSelectValidateValue = (inputValue) => {
        const regExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        return regExp.test(inputValue)
    }

    getRadioDefinitions = (type) => {
        const {
            intl: { formatMessage },
        } = this.props
        const requiredDefinitions =
            type === 'sendingFrequency' ? SENDING_FREQUENCY_DEFINITIONS : SENDING_METHOD_DEFINITIONS

        return requiredDefinitions.map(({ label, value }) => ({
            label: formatMessage({ id: `${LOCALE_PREFIX}.${label}` }),
            value,
        }))
    }

    getRadioTitle = (type) => {
        if (type === 'sendingFrequency') {
            return (
                <div className={'title'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.sendingFrequenciTitle`} />
                </div>
            )
        }
        return (
            <div className={'title'}>
                <FormattedMessage id={`${LOCALE_PREFIX}.sendingMethodTitle`} />
            </div>
        )
    }

    selectNoOptionMessage = () => this.props.intl.formatMessage({ id: `${LOCALE_PREFIX}.badEmail` })

    selectCreateMessage = (value) => `${this.props.intl.formatMessage({ id: `${LOCALE_PREFIX}.addEmail` })} "${value}"`

    handleSubmit = () => false

    render() {
        const { sendingFrequency, intl } = this.props

        return (
            <Form className={'group-monitoring'} onSubmit={this.handleSubmit}>
                <Field
                    name={'recipients'}
                    component={({ input: { value, onChange } }) => {
                        const nextValue = value.toJS ? value.toJS() : value

                        return (
                            <div className={'recipients'}>
                                <div className={'title'}>
                                    <FormattedMessage id={`${LOCALE_PREFIX}.recipientsTitle`} />
                                </div>
                                <div className={'recipients-wrap'}>
                                    <CreatableSelect
                                        name={'recipients'}
                                        value={nextValue}
                                        onChange={onChange}
                                        placeholder={intl.formatMessage({ id: `${LOCALE_PREFIX}.firstEmail` })}
                                        noOptionsMessage={this.selectNoOptionMessage}
                                        formatCreateLabel={this.selectCreateMessage}
                                        isValidNewOption={this.onSelectValidateValue}
                                        styles={selectStyle}
                                        isMulti
                                    />
                                </div>
                            </div>
                        )
                    }}
                />

                <Field
                    name={'sendingFrequency'}
                    component={({ input: { value, onChange } }) => (
                        <RadioGroupComponent
                            radioDefinitions={this.getRadioDefinitions('sendingFrequency')}
                            onChange={onChange}
                            orientation={RADIO_GROUP_ORIENTATIONS.HORIZONTAL}
                            selectedValue={value}
                            componentIdentifier={'sending_frequency'}
                            title={this.getRadioTitle('sendingFrequency')}
                        />
                    )}
                />

                <SendingFrequencySubComponent sendingFrequency={sendingFrequency} />

                <Field
                    name={'sendingMethod'}
                    component={({ input: { value, onChange } }) => (
                        <RadioGroupComponent
                            radioDefinitions={this.getRadioDefinitions('sendingMethod')}
                            onChange={onChange}
                            orientation={RADIO_GROUP_ORIENTATIONS.VERTICAL}
                            selectedValue={value}
                            componentIdentifier={'sending_method'}
                            title={this.getRadioTitle('sendingMethod')}
                        />
                    )}
                />
            </Form>
        )
    }
}
